<label class="ui-checkbox" [class.disabled]="disabled" [for]="id">
    <input
        type="checkbox"
        [id]="id"
        class="ui-checkbox__input"
        [checked]="checked"
        [attr.required]="required ? '' : null"
        [disabled]="disabled"
        (change)="onChangeEvent($event)"
        (blur)="onBlur()"
    />
    <span class="ui-checkbox__box">
        <ui-icon name="check" class="ui-checkbox__check"></ui-icon>
    </span>
    <span class="ui-checkbox__label"><ng-content></ng-content></span>
</label>
